/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScreeningMatchType {
    FUZZY_MATCH = 'FUZZY_MATCH',
    STARTS_WITH = 'STARTS_WITH',
    EXACT_MATCH = 'EXACT_MATCH',
    CONTAINS = 'CONTAINS',
    FUZZY_CONTAINS = 'FUZZY_CONTAINS'
}


export function instanceOfInternalApiScreeningMatchType(value: any): boolean {
    for (const key in InternalApiScreeningMatchType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScreeningMatchType, key)) {
            if (InternalApiScreeningMatchType[key as keyof typeof InternalApiScreeningMatchType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScreeningMatchTypeFromJSON(json: any): InternalApiScreeningMatchType {
    return InternalApiScreeningMatchTypeFromJSONTyped(json, false);
}

export function InternalApiScreeningMatchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningMatchType {
    return json as InternalApiScreeningMatchType;
}

export function InternalApiScreeningMatchTypeToJSON(value?: InternalApiScreeningMatchType | null): any {
    return value as any;
}

export function InternalApiScreeningMatchTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScreeningMatchType {
    return value as InternalApiScreeningMatchType;
}

